/* global axios */
import ApiClient from './ApiClient';

class EngagehubDashboardAPI extends ApiClient {
  constructor() {
    super('engagehub_dashboard', { accountScoped: true });
  }

  fetch(date) {
    // account_id comes from the route via ApiClient's accountScoped base URL;
    // `data` (YYYY-MM-DD) is forwarded by the backend to the webhook.
    const params = date ? { data: date } : {};
    return axios.get(this.url, { params });
  }
}

export default new EngagehubDashboardAPI();
